document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('/products')) {
    if (document.querySelector('.view_section')) {
      var jsON = document.querySelector('#data-json').innerHTML;
      var json = JSON.parse(jsON);
    }
    let HandleParse = window.location.href;
    let HandleParseSplit = HandleParse.split('/');
    let HandleStr = HandleParseSplit[HandleParseSplit.length - 1];
    if (HandleStr.includes('?')) {
      let HanleStrIf = HandleStr.split('?');
      HandleStr = HanleStrIf[0];
    }
    function LocationStorageGETSET() {
      let JsonParse = JSON.parse(localStorage.getItem('ViewedProduct'));
      let GetViewProductArray = JsonParse.handle;
      let GetViewProductArrayLength = GetViewProductArray.length;
      let itr = 0;
      GetViewProductArray.forEach((element, i) => {
        if (GetViewProductArray[i] == HandleStr) {
          itr = GetViewProductArray.length;
        }
      });
      if (itr == 0) {
        let compare_price =  json.compare_at_price ? json.compare_at_price : false;
        JsonParse.title.push(json.title)
        JsonParse.handle.push(json.handle)
        JsonParse.price.push([json.price, compare_price])
        JsonParse.img.push(json.featured_image)
        JsonParse.id.push(json.id)
      }
      localStorage.setItem("ViewedProduct", JSON.stringify(JsonParse));
    }
    if (localStorage.getItem('ViewedProduct')) {
      LocationStorageGETSET()
    } else {
      const forData = {
        title: [],
        handle: [],
        price: [],
        img: [],
        id:[]
      }
      localStorage.setItem("ViewedProduct", JSON.stringify(forData));
      LocationStorageGETSET()
    }
  }
});